import React from 'react'

interface WifiIconProps {
  className?: string;
}

const WifiIcon: React.FC<WifiIconProps> = ({ className }) => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path fillRule="evenodd" clipRule="evenodd" d="M1.5 7.49999L3.16667 9.16665C5.15602 7.17795 7.85376 6.06077 10.6667 6.06077C13.4796 6.06077 16.1773 7.17795 18.1667 9.16665L19.8333 7.49999C17.4007 5.07162 14.1039 3.70773 10.6667 3.70773C7.22942 3.70773 3.93263 5.07162 1.5 7.49999ZM8.16667 14.1667L10.6667 16.6667L13.1667 14.1667C12.8385 13.8381 12.4488 13.5774 12.0198 13.3996C11.5909 13.2217 11.131 13.1302 10.6667 13.1302C10.2023 13.1302 9.74247 13.2217 9.3135 13.3996C8.88453 13.5774 8.49482 13.8381 8.16667 14.1667ZM6.5 12.5L4.83333 10.8333C6.38157 9.28836 8.47945 8.42069 10.6667 8.42069C12.8539 8.42069 14.9518 9.28836 16.5 10.8333L14.8333 12.5C14.2862 11.9527 13.6366 11.5186 12.9217 11.2224C12.2068 10.9262 11.4405 10.7737 10.6667 10.7737C9.89281 10.7737 9.12654 10.9262 8.41161 11.2224C7.69669 11.5186 7.04712 11.9527 6.5 12.5Z" fill="#1E293B"/>
    </svg>
    

  )
}

export default WifiIcon

